import { useQuery, UseQueryResult } from 'react-query';
import { useMerchantIdentification } from './useMerchantIdentification';
import axios, { AxiosError } from 'axios';

export const getBusinessLocation = async (business_location_id: string): Promise<boolean> => {
  try {
    const response = await axios.get(`/api/digital-ordering/locations/${business_location_id}`);
    return response.data;
  } catch (error) {
    console.error('Error getting location app enabled status:', error);
    return false;
  }
};

export function useBusinessLocation(): UseQueryResult<IBusinessLocation, AxiosError> {
  const { data: merchantIdentification } = useMerchantIdentification();

  return useQuery(
    ['business-location', merchantIdentification?.business_location_id],
    () => getBusinessLocation(merchantIdentification?.business_location_id),
    {
      enabled: !!merchantIdentification?.business_location_id,
      staleTime: 5 * 60 * 1000, // 5min
      retry: 1,
    }
  );
}
